import BaseUi from 'nast-ui'

/**
 *
 */
export default class NastUi extends BaseUi {

}
